import {
    fetchGetProductOffers,
    fetchGetApplication,
    fetchGetApplicationsOffers
} from '@iwoca/lapi-client/edge';

import { hasProductDocsComplete } from './lendingAPI/ProductOfferAPIHelper';

type TFormalisationResult = {
    result: 'FORMALISED' | 'DECLINED' | 'DOCS_COMPLETE' | 'DOCS_REQUIRED';
};

export async function autoFormaliseOffers({
    stateKey
}: {
    stateKey: string;
}): Promise<TFormalisationResult> {
    const applicationResponse = await fetchGetApplication({ stateKey });
    const applicationId = applicationResponse.data!.application_id!;

    const offersResponse = await fetchGetApplicationsOffers({ applicationId });

    if (offersResponse.data!.offer_creation_status === 'declined') {
        return { result: 'DECLINED' };
    }

    const offers = offersResponse.data!.offers!;
    if (offers.length > 0) {
        const offer = offers[0];
        if (offer.offer_type === 'confirmed') {
            return { result: 'FORMALISED' };
        }
    }

    const productOffersResponse = await fetchGetProductOffers({
        stateKey
    });

    const suggestedProduct = productOffersResponse.data!.products.find(
        (product) => product.is_suggested
    )!;

    if (hasProductDocsComplete(suggestedProduct)) {
        return { result: 'DOCS_COMPLETE' };
    } else {
        return { result: 'DOCS_REQUIRED' };
    }
}
